module.exports = __webpack_public_path__ + "img/minipack-inactive.74f7e2cc.svg";